"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridItem = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _utils = require("@creditas/utils");

var _components = require("./components");

var _core = require("@emotion/core");

const shapeGridMedia = (0, _propTypes.shape)({
  xs: _propTypes.string,
  md: _propTypes.string
});
const propTypes = {
  area: _propTypes.string,
  gridColumn: shapeGridMedia,
  gridRow: shapeGridMedia,
  justifySelf: _propTypes.string,
  alignSelf: _propTypes.string,
  placeSelf: _propTypes.string
};
const defaultProps = {
  component: 'div',
  justifySelf: '',
  alignSelf: '',
  placeSelf: ''
};
const enhancer = (0, _utils.compose)(_utils.withForwardRef, (0, _utils.withDefaultProps)(propTypes, defaultProps));
const element = enhancer(function (props) {
  const {
    withRef,
    component,
    className,
    area,
    gridRow,
    gridColumn,
    justifySelf,
    alignSelf,
    placeSelf,
    'data-testid': dataTestId,
    ...other
  } = props;
  return (0, _core.jsx)(_components.GridItem, (0, _extends2.default)({
    as: component,
    ref: withRef,
    className: className,
    "data-testid": dataTestId,
    area: area,
    gridRow: gridRow,
    gridColumn: gridColumn,
    justifySelf: justifySelf,
    alignSelf: alignSelf,
    placeSelf: placeSelf
  }, other));
});
exports.GridItem = element;